import { render, staticRenderFns } from "./ModalSlotted.vue?vue&type=template&id=31adf3e8&scoped=true"
import script from "./ModalSlotted.vue?vue&type=script&lang=js"
export * from "./ModalSlotted.vue?vue&type=script&lang=js"
import style0 from "./ModalSlotted.vue?vue&type=style&index=0&id=31adf3e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31adf3e8",
  null
  
)

export default component.exports